import { render } from "./ChatLIst.vue?vue&type=template&id=3955695c&scoped=true"
import script from "./ChatLIst.vue?vue&type=script&lang=js"
export * from "./ChatLIst.vue?vue&type=script&lang=js"

import "./ChatLIst.vue?vue&type=style&index=0&id=3955695c&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3955695c"]])

export default __exports__